<template>
    <div class="contract-image" ref="addImage">
        <!-- <div @click="generatorImage" class="img-btn">生成圖片</div> -->
        <!-- <div class="contract-cover"></div> -->
        <!-- <img v-if="houseDetailImage" :src="houseDetailImage" alt=""> -->
        <div v-if="!houseDetailImage" ref="capture" class="image-content">
            <share-house v-if="houseId" :houseCid="houseId"></share-house>
        </div>     
    </div>
</template>
<script>
import html2canvas from 'html2canvas'
import shareHouse from '@/pages/shareHouse/shareHouse.vue'

import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            houseDetailImage: null
        }
    },
    mounted() {
        setTimeout(()=>{
            console.log('settimeout')
            if(this.isMapLoaded === false){
                console.log('map=false')
                this.generatorImage()
            }
        },6000)
        // window.open('http://127.0.0.1:8080/bussiness/mgtCategory/bookingMgt/bizContract?cid=3854','簽署合約','width=3440,height=1080,resizable=no'); 
    },
    watch: {
        isMapLoaded: function (val) {
            console.log('isMapLoaded', val)
            if(val){
                this.generatorImage()
            }
        }
    },
    methods: {
        generatorImage: function () {
            html2canvas(this.$refs.capture, { useCORS: true}).then(canvas => { 
                console.log(canvas)
                this.houseDetailImage = canvas.toDataURL( 'image/png' );

                this.$store.dispatch('setSignData',{type: 'ad', value: this.houseDetailImage})
                this.$emit('toImage', this.houseDetailImage)
            })
        },
    },
    computed: {
        ...mapGetters({
            isMapLoaded: 'GET_SHARE_HOUSE_MAP_LOADED',
            houseId: 'GET_BIZ_HOUSE_ID'
        })
    },
    components: {
        shareHouse,
    }
}
</script>
<style lang="scss" scoped>
    .contract-image{
        position: relative;
        .contract-cover{
            position: absolute;
            background: #fff;
        }
        .image-content{
            min-width: 1280px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/bookingMgt/bizContract/html2image.vue